import React, { Dispatch, ReactElement, SetStateAction } from 'react';
import { DatePicker, FormGroup, Label } from 'idsk-react-components';
import { ExpansionPanel } from 'slovlex-idsk-react-components';
import SearchInput from './SearchInput';
import './sidePanel.scss';
import NavrhAktuEuFilter from '../../../model/NavrhAktuEuFilter';
import { SafeParameterSetter } from '../../../types/SafeParameterSetter';
import TypSingleSelect from '../../VyhladavaniePravoEu/component/TypSingleSelect';
import InstituciaSingleSelect from './InstituciaSingleSelect';

interface Props {
  filter: NavrhAktuEuFilter;
  onUpdateField: SafeParameterSetter<NavrhAktuEuFilter>;
  filterCopy: NavrhAktuEuFilter;
  onUpdateFieldCopy: SafeParameterSetter<NavrhAktuEuFilter>;
  setFilter: Dispatch<SetStateAction<NavrhAktuEuFilter>>,
}

const SidePanel = ({
  filter,
  onUpdateField,
  filterCopy,
  onUpdateFieldCopy,
  setFilter,
}: Props): ReactElement => (
  <div className="akt-eu-list-side-panel">
    <SearchInput
      filterCopy={filterCopy}
      label="Hľadaný výraz"
      filterSearchText={filterCopy?.hladanyVyraz}
      fieldName="hladanyVyraz"
      onUpdateFieldCopy={onUpdateFieldCopy}
      setFilter={setFilter}
      className="slovlex-idsk-side-panel-input-wrapper first-container"
    />
    <SearchInput
      filterCopy={filterCopy}
      label="Číslo procesu"
      filterSearchText={filterCopy?.cisloLegislativnehoMaterialu}
      fieldName="cisloLegislativnehoMaterialu"
      onUpdateFieldCopy={onUpdateFieldCopy}
      setFilter={setFilter}
      className="slovlex-idsk-side-panel-input-wrapper"
    />
    <SearchInput
      filterCopy={filterCopy}
      label="Identifikátor aktu"
      filterSearchText={filterCopy?.identifikatorAktu}
      fieldName="identifikatorAktu"
      onUpdateFieldCopy={onUpdateFieldCopy}
      setFilter={setFilter}
      className="slovlex-idsk-side-panel-input-wrapper"
    />
    <SearchInput
      filterCopy={filterCopy}
      label="Názov procesu"
      filterSearchText={filterCopy?.nazovLegislativnehoMaterialu}
      fieldName="nazovLegislativnehoMaterialu"
      onUpdateFieldCopy={onUpdateFieldCopy}
      setFilter={setFilter}
      className="slovlex-idsk-side-panel-input-wrapper"
    />
    <SearchInput
      filterCopy={filterCopy}
      label="Názov aktu EÚ"
      filterSearchText={filterCopy?.nazovAktu}
      fieldName="nazovAktu"
      onUpdateFieldCopy={onUpdateFieldCopy}
      setFilter={setFilter}
      className="slovlex-idsk-side-panel-input-wrapper"
    />
    <TypSingleSelect
      onUpdateField={onUpdateField}
      onUpdateFieldCopy={onUpdateFieldCopy}
      filter={filter}
      filterCopy={filterCopy}
      isNavrhAktuEu
    />
    <InstituciaSingleSelect
      onUpdateField={onUpdateField}
      onUpdateFieldCopy={onUpdateFieldCopy}
      filter={filter}
      filterCopy={filterCopy}
    />
    <ExpansionPanel title="Medziinštitucionálny kód" isExpanded={filter.medziinstitucionalnyKod !== ''}>
      <SearchInput
        filterSearchText={filterCopy?.medziinstitucionalnyKod}
        fieldName="medziinstitucionalnyKod"
        onUpdateFieldCopy={onUpdateFieldCopy}
        filterCopy={filterCopy}
        setFilter={setFilter}
      />
    </ExpansionPanel>

    <ExpansionPanel
      title="Dátum prijatia"
      isExpanded={!!filter.datumPrijatiaAktuOd || !!filter.datumPrijatiaAktuDo}
    >
      <FormGroup>
        <FormGroup>
          <Label htmlFor="prijatieOd">Dátum od</Label>
          <DatePicker
            id="prijatieOd"
            showIcon
            value={filter?.datumPrijatiaAktuOd}
            onChange={date => onUpdateField('datumPrijatiaAktuOd', date)}
            strictParsing
          />
        </FormGroup>
        <FormGroup>
          <Label htmlFor="prijatieOd">Dátum do</Label>
          <DatePicker
            id="prijatieDo"
            showIcon
            value={filter?.datumPrijatiaAktuDo}
            onChange={date => onUpdateField('datumPrijatiaAktuDo', date)}
            strictParsing
          />
        </FormGroup>
      </FormGroup>
    </ExpansionPanel>
  </div>
);
export default SidePanel;
